import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { MultipleImageUploader, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";
import Constants from "constants/index";

import { Mode } from "constants/enum";
import { IDataDetailAnalysis } from "commons/interfaces";



export const CardImageAnalysis = ({
    mode,
    dataAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
}) => {
    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.IMAGE_ANALYSIS}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MultipleImageUploader
                        mode={mode}
                        optimize={false}
                        folderPath={Constants.CloudStorage.ANALYSIS_PHOTO}
                        defaultValue={[...dataAnalysis?.analyzePhotoUrls || []]}
                        onChange={(value) => {
                            handleChangeValue("analyzePhotoUrls", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardImageAnalysis;
